import {AdminApi} from "./AdminApi";
import { Location } from "../../../models/Location";

const AdminBrandsApi = AdminApi.injectEndpoints({
  endpoints: (builder) => ({
    getContextLocation: builder.query<Location, {brandSlug: string, locationSlug: string}>({
      query: ({brandSlug, locationSlug}) => {
        return {
          url: `brands/${brandSlug}/locations/${locationSlug}/context`,
          method: "GET"
        };
      },
      keepUnusedDataFor: 30,
      providesTags: [{type: "Locations", id: "urlSlug"}]
    }),
  }),
});

export const {
  useGetContextLocationQuery,
} = AdminBrandsApi;
